// frontend/src/config/report-systems.js

/**
 * REPORT_SYSTEMS — single source of truth for ERP report system tabs.
 *
 * Each entry here produces one tab on the Reports page (visible when
 * REPORT_SYSTEMS.length >= 2; collapses to a plain "Reports" tab otherwise).
 *
 * ─── FIELDS ────────────────────────────────────────────────────────────────
 *   id        — unique identifier, used as the React key; MUST match a `key` in
 *               REPORT_SYSTEM_PERMISSIONS in permissions-registry.js
 *   label     — tab label shown to the user
 *   sourceKey — must match BOTH:
 *                 • the folder name in apix-query-system/core/v3.0/src-{sourceKey}/
 *                 • the "erp_source" value written to catalog.json by merge.js
 *   hashKey   — URL hash fragment for bookmarkable deep-links (no spaces/slashes)
 *
 * ─── ADDING A NEW ERP SYSTEM ───────────────────────────────────────────────
 *   1. Append a new entry to REPORT_SYSTEMS below.
 *   2. Create a src-{sourceKey}/reports/ folder in apix-query-system/core/v3.0/
 *      and add .params.json + .sql report files following the existing structure.
 *   3. Re-run the apix-query-system build pipeline (merge.js + CodeBuild deploy).
 *      merge.js will automatically set erp_source: "{sourceKey}" on all new entries
 *      by detecting the src-* folder name — no manual catalog edits needed.
 *   4. That's it. The new tab appears for all users automatically.
 *
 * ─── PERMISSION GATING (optional future enhancement) ───────────────────────
 *   To show a tab only to users with a specific module enabled, filter
 *   visibleSystems in ReportsModule.js using the same isModuleEnabled() pattern
 *   as Home.js (see frontend/src/pages/Home.js isTabVisible for the pattern).
 */
export const REPORT_SYSTEMS = [
  {
    id: 'lawson',
    label: 'Lawson',
    sourceKey: 'lawson',
    hashKey: 'lawson_reports',
  },
  {
    id: 'infor-ghr',
    label: 'Infor GHR',
    sourceKey: 'landmark',   // matches the src-landmark folder in apix-query-system
    hashKey: 'infor_ghr_reports',
  },
]
